import style from "./index.module.scss";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Analytics } from "../../../services";
import BasicAnalytics from "../components/BasicAnalytics";
import OrderCountByPeriod from "../components/OrderCountByPeriod";
import TopDirections from "../components/TopDirections";
import SLAComplianceByExpeditor from "../components/SLAComplianceByExpeditor";
import TopDirectionsMobile from "../components/TopDirectionsMobile";
import { useScreenSize } from "../../../hooks/useScreenSize";
import AnalyticsByClientOrders from "../components/AnalyticsByClientOrders";
import AnalyticsByClientPublicOrders from "../components/AnalyticsByClientPublicOrders";
import TopDirectionsTable from "../components/TopDirectionsTable";
import ParticipationInTendersChart from "../components/ParticipationInTendersChart";
import OrderCountByPeriodExpeditor from "../components/OrderCountByPeriodExpeditor";
import CreatedOrdersByEmployee from "../components/CreatedOrdersByEmployee";

const AnalyticsAviationExpeditor = ({ user }) => {
  const { t } = useTranslation();
  const { isMobileView } = useScreenSize();

  const [baseMetricDateStart, setBaseMetricDateStart] = useState(moment().subtract(30, "days").toDate());
  const [baseMetricDateEnd, setBaseMetricDateEnd] = useState(new Date());
  const [currency, setCurrency] = useState("");

  const [baseMetric, setBaseMetric] = useState();
  const [topAirRoutes, setTopAirRoutes] = useState([]);
  const [SLACompliance, setSLACompliance] = useState([]);
  const [turnover, setTurnover] = useState([]);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [publicOrders, setPublicOrders] = useState([]);
  const [top10DirectionsTable, setTop10DirectionsTable] = useState();
  const [tenderStats, setTenderStats] = useState([]);
  const [transportationCount, setTransportationCount] = useState([]);
  const [employeeOrders, setEmployeeOrders] = useState([]);

  const [baseMetricIsCompleted, setBaseMetricIsCompleted] = useState(true);
  const [topDirectionsIsCompleted, setTopDirectionsSatatusIsCompleted] = useState(true);
  const [turnoverIsCompleted, setTurnoverIsCompleted] = useState(true);
  const [top10DirectionsTableIsCompleted, setTop10DirectionsTableIsCompleted] = useState(true);

  const startDate = useMemo(() => moment(baseMetricDateStart).format("YYYY-MM-DD"), [baseMetricDateStart]);
  const endDate = useMemo(() => moment(baseMetricDateEnd).format("YYYY-MM-DD"), [baseMetricDateEnd]);

  const fetchAnalyticsData = async (apiFunc, setter, ...extraArgs) => {
    try {
      const currencyParam = currency === "all" || currency === "" ? "" : currency;
      const response = await apiFunc(startDate, endDate, currencyParam, ...extraArgs);
      setter(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchAnalyticsData(Analytics.getAirOrderIndicatorsExpeditor, setBaseMetric, baseMetricIsCompleted);
    fetchAnalyticsData(Analytics.getAirTurnoverExpeditor, setTurnover, turnoverIsCompleted);
    fetchAnalyticsData(Analytics.getAirTopDirectionsExpeditor, setTopAirRoutes, topDirectionsIsCompleted);
    fetchAnalyticsData(Analytics.getAirParticipationInTenders, setTenderStats);
    fetchAnalyticsData(Analytics.getAirCountOfTransportation, setTransportationCount);
    // fetchAnalyticsData(Analytics.getAirClientEmployeesCreatedOrdersExpeditor, setEmployeeOrders);
    // fetchAnalyticsData(Analytics.getAirExecutionOrdersOnTime, setSLACompliance);
    fetchAnalyticsData(Analytics.getAirTop10RoutesExpeditor, setTop10DirectionsTable, top10DirectionsTableIsCompleted);

    // fetchAnalyticsData(Analytics.getAirClientCreatedCompletedOrders, setCompletedOrders);
    // fetchAnalyticsData(Analytics.getAirClientCreatedPublicOrders, setPublicOrders);
  }, [baseMetricDateStart, baseMetricDateEnd, currency]);

  useEffect(() => {
    fetchAnalyticsData(Analytics.getAirTopDirectionsExpeditor, setTopAirRoutes, topDirectionsIsCompleted);
  }, [topDirectionsIsCompleted]);

  useEffect(() => {
    fetchAnalyticsData(Analytics.getAirTop10RoutesExpeditor, setTop10DirectionsTable, top10DirectionsTableIsCompleted);
  }, [top10DirectionsTableIsCompleted]);

  useEffect(() => {
    fetchAnalyticsData(Analytics.getAirTurnoverExpeditor, setTurnover, turnoverIsCompleted);
  }, [turnoverIsCompleted]);

  return (
    <>
      <div className={style.wrapperAnalytics}>
        <BasicAnalytics
          item={baseMetric}
          startDate={baseMetricDateStart}
          setStartDate={setBaseMetricDateStart}
          endDate={baseMetricDateEnd}
          setEndtDate={setBaseMetricDateEnd}
          currency={currency} 
          setCurrency={setCurrency}
          isExpeditor
        />

        <div className={style.metric}>
          <OrderCountByPeriod
            item={turnover}
            isExpeditor
            isCompleted={turnoverIsCompleted}
            setIsCompleted={setTurnoverIsCompleted}
            currency={currency}
          />

          {isMobileView ? (
            <TopDirectionsMobile
              item={topAirRoutes}
              isExpeditor
              isCompleted={topDirectionsIsCompleted}
              setIsCompleted={setTopDirectionsSatatusIsCompleted}
            />
          ) : (
            <TopDirections
              item={topAirRoutes}
              isExpeditor
              isCompleted={topDirectionsIsCompleted}
              setIsCompleted={setTopDirectionsSatatusIsCompleted}
            />
          )}
        </div>

        <div className={style.metric}>
          <ParticipationInTendersChart item={tenderStats} />
          <OrderCountByPeriodExpeditor item={transportationCount} />
        </div>
        
        {/* <div className={style.metric}>
          <CreatedOrdersByEmployee item={employeeOrders} />
          <SLAComplianceByExpeditor item={SLACompliance} />
        </div> */}

        <TopDirectionsTable
          top10DirectionsTable={top10DirectionsTable}
          isExpeditor
          isCompleted={top10DirectionsTableIsCompleted}
          setIsCompleted={setTop10DirectionsTableIsCompleted}
          currency={currency}
        />

        {/* old */}
        {/* <div className={style.metric}>
          <AnalyticsByClientOrders item={completedOrders} />
          <AnalyticsByClientPublicOrders item={publicOrders} />
        </div> */}
      </div>
    </>
  );
};

export default AnalyticsAviationExpeditor;
